export default __webpack_public_path__ + "static/media/U.2bc593b4.svg";